import { Component, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { LessonCurriculumApiService } from '../../services/lesson-curriculum-api.service';

@Component({
  selector: 'app-create-lesson-curriculum',
  templateUrl: './create-lesson-curriculum.component.html',
  standalone: false
})
export class CreateLessonCurriculumComponent implements OnDestroy {
  ngUnsubscribe = new Subject<void>();

  curriculumForm = new FormGroup({
    curriculum_name: new FormControl('', [Validators.required]),
    description: new FormControl(''),
  });

  constructor(
    private location: Location,
    private lessonCurriculumApiService: LessonCurriculumApiService,
    private toastrService: ToastrService,
  ) {}

  onSubmit() {
    if (this.curriculumForm.invalid) return;
    this.lessonCurriculumApiService.createCurriculum({ ...this.curriculumForm.value, curriculum_type: 'lesson_plan' })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: res => {
        if (res) {
          this.toastrService.success('Yearly Plan created');
          this.navigateBack();
        } else {
          this.toastrService.error('Something went wrong');
        }
        },
        error: error => {
          this.toastrService.error(error?.error?.message || 'Something went wrong');
        },
      });
  }

  navigateBack() {
    this.location.back();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }
}
